export enum ToolSortColumn {
  Description = 'description',
  Quantity = 'quantity',
}
